<template>
  <div class="redpacket">
    <div class="bg-pic" :style="'background-image:url('+img.res_bg+')'">
      <a class="f-r f-14 f-w pd-15" href="redinfo">红包明细</a>
    </div>
    <div class="tools-list">
     <div class="tools-items">
      <div>
        <span class="f-18 f-w">￥</span>
        <span class="f-30 f-w">100.00</span>
      </div>
      <div class="f-14 f-w">红包(元)</div>
    </div>
  </div>
  <div class="pd-15 f-14 f-w">当前红包</div>
  <div class="pd-15 redList">
    <div class="red">
      <van-row>
        <van-col class="c-red f-15 f-w mt-20" span="1">￥</van-col>
        <van-col class="text-c c-red" span="4">
          <div class="f-w f-30">5</div>
          <div class="f-12">红包</div>
        </van-col>
        <van-col class="f-w f-15 mt-15" span="12">
          5元玻璃水红包
        </van-col>
        <van-col span="7" class="text-r"><van-tag color="#F6AB00" round>立即使用</van-tag>  </van-col>
      </van-row>
      <van-divider />
      <van-row type="flex" justify="space-between">
        <van-col span="12">
          <div class="f-12 c-gray f-l">有效期至：2019-12-31</div>
        </van-col>
        <van-col span="12">
          <div class="f-12 c-org f-r">使用规则</div>
        </van-col>
      </van-row>

    </div>
  </div>
</div>
</template>
<script>
  import list from '../../../api/member/mycollect';
  import {  List, Row, Col,Tag,Divider} from 'vant'
  export default {
    data () {
      return {
        list: [],
        img:{
          res_bg: require('../../../assets/img/member/myred_bg.png'),
        }
      }
    },
    created () {
      this.$store.commit('param/show', false)
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {

    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tag.name]: Tag,
      [Divider.name]:Divider
    }
  };
</script>

<style lang="scss">
.redpacket{
  .bg-pic {
   width: 100%;
   height: 150px;
   background-size: 100% 220px;
   background-repeat: no-repeat;
   background-position: center;
   a{
    color: #3A3A3A;
  }
}
.tools-list {
  margin-top: -90px;
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
}
.tools-items {
  padding: 30px 20px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 1px 0 2px 0 #dedad9, 1px 3px 5px 0 #dad4d3;
  .f-30{
    font-size: 30px;
    letter-spacing: 2px;
  }
}
.pd-15{
  padding: 15px;
}
.redList{
  .red{
   padding: 20px 20px;
   background: #fff;
   border-radius: 5px;
   box-shadow: 1px 0 2px 0 #dedad9, 1px 3px 5px 0 #dad4d3;
   .f-30{
    font-size: 30px;
  }
  .van-tag{
    padding: 10px 18px;
    margin-top: 8px;
    border-radius: 20px;
  }
  .mt-20{
    margin-top: 20px;
  }
  .mt-15{
    margin-top: 15px;
  }
}
}
}
</style>
